ui-cms-content-footer {
  .buttons-wrapper {
    width: 100%;
    display: flex;

    sd-button {
      margin-bottom: $sd-spacing-4;
    }

    &__print {
      margin-right: auto;
    }

    &__scroll {
      margin-left: auto;
    }
  }
}
